var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(999) 999-9999'),expression:"'(999) 999-9999'"}],staticClass:"form-control",attrs:{"type":"tel","placeholder":"(123) 456-7890"},domProps:{"value":_vm.formattedValue},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }